import { ANALYTICS_KEY } from '../../constants.js';
import '../../ui/Div/index.js';
import '../../ui/Link/index.js';
import { Text } from '../../ui/Text.js';
import { jsx } from 'react/jsx-runtime';
import { Div } from '../../ui/Div/Div.js';
import { Link } from '../../ui/Link/Link.js';
function Banner({
  label,
  url
}) {
  if (!label) return null;
  return /*#__PURE__*/jsx(Div, {
    as: "nav",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    background: "primary",
    spacingVertical: 0.5,
    spacingHorizontal: 3,
    zIndex: 20,
    children: /*#__PURE__*/jsx(Link, {
      href: url || '',
      "data-qa": ANALYTICS_KEY.Banner,
      children: /*#__PURE__*/jsx(Text, {
        variant: "body",
        color: "background",
        css: {
          textAlign: 'center'
        },
        children: label
      })
    })
  });
}
export { Banner };
//# sourceMappingURL=Banner.js.map
